import { Grid, Paper } from "@material-ui/core";
import { useGetLotPhotosQuery } from "features/lots/lotSlice";
import FadeInImage from "features/vehicles/components/FadeInImage";
import { IconDirection, IconPhoto } from "icons";
import { lotDispatchDetailsStyle } from "../style";

const LotPhotos = ({
    lot, onEdit
}) => {

    let { data: photos, error: attachmentsError, isFetching: isLoadingAttachments } = useGetLotPhotosQuery(lot?.id, { skip: !lot?.id });
    const classes = lotDispatchDetailsStyle();

    return (
        <Grid direction='column' spacing={1}>
            <Paper className={classes.detailCard}>
                <div className={classes.cardHeader}>
                    <div className={classes.cardHeaderTitle}>
                        <IconPhoto className={classes.titleIcon} />
                        <div className={classes.cardTitle}>Lot Photos</div>
                    </div>

                </div>
                <Grid container spacing={1}>
                    {photos?.map((image, index) => (
                        <Grid key={index} item xs={3}>
                            <FadeInImage
                                img={image}
                                imagesForCarousel={photos}
                                showCarousel
                                alt={`Image`}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Paper>
        </Grid>
    )
}
export default LotPhotos;
